import React from 'react';

import { getDebugLog } from '@/utils/tempDebugLog';

// TEMP DEBUG - remove after diagnosing the create-password regression.
const TempDebugOverlay = () => {
  const entries = getDebugLog();
  return (
    <div style={{
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      maxHeight: '60vh',
      overflow: 'auto',
      background: 'rgba(0,0,0,0.9)',
      color: '#0f0',
      fontSize: 10,
      fontFamily: 'monospace',
      padding: 8,
      zIndex: 999999,
      whiteSpace: 'pre-wrap',
      wordBreak: 'break-all',
    }}
    >
      {entries.length === 0 && '(sin logs todavia)'}
      {entries.map((entry, i) => (
        // eslint-disable-next-line react/no-array-index-key
        <div key={i} style={{ marginBottom: 6, borderBottom: '1px solid #333' }}>
          {`${entry.time}\n${entry.label}\n${JSON.stringify(entry.data, null, 1)}`}
        </div>
      ))}
    </div>
  );
};

export default TempDebugOverlay;
